module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [(!_vm.hidePanel) ? _c('edit-pane', {
    ref: "ep",
    attrs: {
      "prefix": "Permit: ",
      "title": _vm.form.summary,
      "editable": _vm.isManager('project|maintenance|finance|property|admin') ? true : false,
      "is-edit": _vm.editMode
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit,
      "add": _vm.onSave
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "permitDetailsForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "90px"
    }
  }, [(!_vm.localSiteId) ? _c('select-site', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.form.site_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "site_id", $$v)
      },
      expression: "form.site_id"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "permitType",
      "label": "Permit"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": "Permit Type (e.g. Microwave License)"
    },
    model: {
      value: (_vm.form.permitType),
      callback: function($$v) {
        _vm.$set(_vm.form, "permitType", $$v)
      },
      expression: "form.permitType"
    }
  })], 1), _vm._v(" "), _c('select-authority', {
    attrs: {
      "required": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.organisation_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "organisation_id", $$v)
      },
      expression: "form.organisation_id"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Applied",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.applied),
      callback: function($$v) {
        _vm.$set(_vm.form, "applied", $$v)
      },
      expression: "form.applied"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Issued",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.issued),
      callback: function($$v) {
        _vm.$set(_vm.form, "issued", $$v)
      },
      expression: "form.issued"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Expiry",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.expiry),
      callback: function($$v) {
        _vm.$set(_vm.form, "expiry", $$v)
      },
      expression: "form.expiry"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "amount",
      "label": "Amount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.amount),
      callback: function($$v) {
        _vm.$set(_vm.form, "amount", $$v)
      },
      expression: "form.amount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-frequency', {
    attrs: {
      "label": "Period",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.renewalPeriod),
      callback: function($$v) {
        _vm.$set(_vm.form, "renewalPeriod", $$v)
      },
      expression: "form.renewalPeriod"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "ref1",
      "label": _vm.label1
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.ref1),
      callback: function($$v) {
        _vm.$set(_vm.form, "ref1", $$v)
      },
      expression: "form.ref1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "ref2",
      "label": _vm.label2
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.ref2),
      callback: function($$v) {
        _vm.$set(_vm.form, "ref2", $$v)
      },
      expression: "form.ref2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('html-input', {
    attrs: {
      "label": "Remarks",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.remarks),
      callback: function($$v) {
        _vm.$set(_vm.form, "remarks", $$v)
      },
      expression: "form.remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.form.updated_at) ? _c('div', [_c('hr'), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("Last update: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.form.updated_at)))]), (_vm.form.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.form.updated_by))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('finance|admin|management') && _vm.form.site_id && _vm.form.id) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('files-panel', {
    attrs: {
      "title": "Permits",
      "type": "site",
      "id": _vm.form.site_id,
      "process": "permits",
      "process-id": _vm.form.id,
      "max-files": 20
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-034a2114"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/permits/PermitDetails.vue
// module id = 1392
// module chunks = 0